import { API } from "../store"

export const subscribe = body => dispatch => {
  return new Promise((resolve, reject) => {
    API.post("/subscribe")
      .send(body)
      .then(res => res.body)
      .then(data => resolve(data))
      .catch(err => reject(err))
  })
}

export const checkSubscription = id => dispatch => {
  return new Promise((resolve, reject) => {
    API.get("/subscribe/" + id)
      .then(res => res.body)
      .then(data => resolve(data))
      .catch(err => reject(err))
  })
}

export const endSubscription = id => dispatch => {
  return new Promise((resolve, reject) => {
    API.get("/unsubscribe/" + id)
      .then(res => res.body)
      .then(data => resolve(data))
      .catch(err => reject(err))
  })
}

export const reloadUser = id => dispatch => {
  return new Promise((resolve, reject) => {
    API.get("/users/" + id)
      .then(res => res.body)
      .then(data => resolve(data))
      .catch(err => reject(err))
  })
}
